module.exports = __webpack_public_path__ + "img/mrt_vision_plus.eefa176d.jpg";